module.exports = __webpack_public_path__ + "static/img/4.eda032c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20200904/4.png
// module id = MOhp
// module chunks = 1